<div class="video">
  <div class="video__backdrop"
       (click)="closeVideo(video)"></div>

  <video
         [attr.poster-src]="poster"
         controlsList="nodownload"
         preload="auto"
         #video>
    <source
            [attr.video-src]="src"
            type="video/mp4">
  </video>

  <button class="video__play-btn dds-icon dds-icon_play__l__stroke"
          (click)="playVideo(video)"></button>

  <dds-button class="video__close-btn"
              icon="dds-icon_close__s__stroke"
              [isInverse]="true"
              theme="dark"
              (clicked)="closeVideo(video)"></dds-button>
</div>
